import { IEnrolState } from '../states/enrol.state'
import * as fromActions from '../actions/enrols.action'
import { Reducer } from 'redux'
import { IEnrolModel } from 'models/enrol.model'

export const initialState: IEnrolState = {
  list: [],
  adminList: [],
  enrol: {} as IEnrolModel,
}

export const reducer: Reducer<IEnrolState> = (state: IEnrolState = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.ENROL_LIST_SUCCESS:
      return {
        ...state,
        list: payload,
      }
    case fromActions.ENROL_ADMIN_LIST_SUCCESS:
      return {
        ...state,
        adminList: payload,
      }
    default:
      return state
  }
}
